"use strict";

var _defineProperty = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/defineProperty");

var _objectWithoutProperties = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/objectWithoutProperties");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BlobHersey = void 0;

var React = __importStar(require("react"));

exports.BlobHersey = React.forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      props = _objectWithoutProperties(_ref, ["color"]);

  return React.createElement("svg", _objectSpread(_objectSpread({
    width: "461",
    height: "157",
    viewBox: "0 0 461 157",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    ref: forwardedRef
  }), React.createElement("g", {
    "clip-path": "url(#clip0)"
  }, React.createElement("path", {
    d: "M36 82H26V154H0V2H25V60H36V2H62V154H36V82Z",
    fill: color
  }), React.createElement("path", {
    d: "M271 2H296V60H307V2H333V154H308V82H297V154H271V2Z",
    fill: color
  }), React.createElement("path", {
    d: "M131 1.59007C145.25 1.59007 159.14 1.02007 173 1.77007C184 2.37007 191.35 12.1901 191.81 25.2801C192.12 34.1001 192.1 42.9501 191.81 51.7701C191.53 59.6301 188.55 66.3701 180.88 71.3501C191.57 77.8001 191.48 87.9701 191.33 98.3501C191.16 109.67 191.24 121.01 191.65 132.35C191.93 140.35 194.13 147.78 201.03 154.41C190.4 154.41 180.82 154.52 171.24 154.27C170.13 154.27 168.36 152.41 168.11 151.17C167.004 146.482 166.334 141.702 166.11 136.89C165.87 121.57 166.05 106.24 166.01 90.8901C166.01 83.4001 164.23 81.8901 156.06 82.8201V154H131V1.59007ZM157 62.5001C164.6 63.0901 166.78 61.2401 166.82 54.5001C166.86 47.3467 166.86 40.1934 166.82 33.0401C166.82 25.8101 164.59 24.0401 157 25.4301V62.5001Z",
    fill: color
  }), React.createElement("path", {
    d: "M200.64 100H225.57C225.57 109.18 225.45 118.09 225.65 127C225.66 129.095 226.363 131.127 227.65 132.78C228.54 133.78 231.28 134.1 232.58 133.46C234.05 132.74 235.69 130.64 235.74 129.1C235.98 120.99 236.47 112.76 235.39 104.78C234.8 100.37 231.85 95.9301 228.99 92.2601C223.1 84.6901 216.37 77.7801 210.35 70.2601C204.109 62.586 200.915 52.8807 201.38 43.0001C201.55 37.5301 201.38 32.0001 201.38 26.5801C201.59 11.7801 209.47 2.58006 224.09 0.520061C228.703 -0.121689 233.381 -0.14523 238 0.450061C251.87 2.29006 259.33 10.4501 259.95 24.3201C260.32 32.7201 260.01 41.1601 260.01 49.9601H235.88C235.88 46.6801 235.88 43.4201 235.88 40.1701C235.88 35.8601 236.2 31.4901 235.53 27.2801C235.27 25.6701 232.78 23.5501 231.07 23.2801C229.78 23.1001 226.89 25.4601 226.82 26.8101C226.22 38.0301 225.14 49.3301 234.19 58.5601C240.45 65.0001 246 72.0901 251.76 79.0001C257.967 86.5392 261.279 96.0463 261.1 105.81C260.99 112.67 260.72 119.56 261.1 126.4C262.51 149.21 244.58 157.09 228.92 156.68C210.52 156.21 199.15 145.79 200.31 126.93C200.75 119.66 200.36 112.34 200.39 105.05C200.43 103.45 200.56 101.83 200.64 100Z",
    fill: color
  }), React.createElement("path", {
    d: "M397.51 2H423.71L431.27 53.43H432.4C434.76 36.43 439.52 3.02 439.52 3.02H460.25C456.6 24.07 453.61 45.02 449.25 65.61C443.493 92.5894 441.161 120.187 442.31 147.75C442.4 149.7 442.31 151.67 442.31 154.02H416.2C416.07 152.97 415.81 151.72 415.77 150.46C415.7 147.8 415.59 145.13 415.77 142.46C417.77 113.65 412.52 85.58 407.23 57.46C403.8 39.2 400.8 20.86 397.51 2Z",
    fill: color
  }), React.createElement("path", {
    d: "M101 61H119V83H101V132H122V154H74V2H120V24H101V61Z",
    fill: color
  }), React.createElement("path", {
    d: "M372 132.23C377.45 132.23 382.76 132.53 388 132.13C392.58 131.79 393.77 133.52 393.49 137.79C393.15 143.03 393.41 148.32 393.41 153.96H346V2H391V24H372V61H390V83H372V132.23Z",
    fill: color
  })), React.createElement("defs", null, React.createElement("clipPath", {
    id: "clip0"
  }, React.createElement("rect", {
    width: "460.25",
    height: "156.72",
    fill: "white"
  }))));
});